module.exports = __webpack_public_path__ + "assets/img/es-4c22beed.png";